import React from "react";
import { Stack, Skeleton } from "@curves/ui-base";

const ChartSkeletonLoading = props => {
	return (
		<Stack direction="column" spacing={1} className="m-3">
			<Skeleton animation="wave" width="30%" height={40} />
			<Skeleton animation="wave" width="25%" height={36} />
			<Skeleton animation="wave" variant="rectangular" width={"95%"} height={300} />
		</Stack>
	);
};

export default ChartSkeletonLoading;
